import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const SleepChart = () => {

    const [chartData, setChartData] = useState({
        series: [
            {
                name: 'Series 1',
                data: [80, 50, 30, 40, 100, 20, 10],
            },
        ],
        options: {
            chart: {
                type: 'radar',
                dropShadow: {
                    enabled: true,
                    blur: 1,
                    left: 1,
                    top: 1,
                },
                toolbar: {
                    show: false,
                },
            },

            stroke: {
                width: 2,
            },
            fill: {
                opacity: 0.4,
            },
            markers: {
                size: 0,
            },
            xaxis: {
                categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fry', 'Sat', 'Sun'],
            },
            colors: ['#30B091'],

        },
    });


    return (
        <>
            <div id="chart">
                <ReactApexChart options={chartData.options} series={chartData.series} type="radar" width="100%" height={180} />
            </div>
        </>
    )
}

export default SleepChart
